import React, { useState } from "react";
import "./Style.css";
import { Avatar } from "@mui/material";
import Logo from "../../../assets/images/LOGO/hostHelperImage/image 1 (1).png";
import { useForm } from "react-hook-form";
import { ERROR_MSG, SUCCESS_MSG } from "../../../components/Custom_Message";
import { useNavigate } from "react-router";
import { ABC } from "../../../Api/Api";
import { Button, Row, Col } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { Login_Api } from "../../../Api/Api";
// import { ToastContainer, toast } from "react-toastify";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import { kkKZ } from "@mui/material/locale";

const Login = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showPass, setShowPass] = useState(false);

  const Login_Admin = async (Credential) => {
    const res = await Login_Api(Credential);
    console.log("res==>", res, res?.success, res?.success === false);

    if (res?.success === false) {
      // console.log("res", res?.msg);
      toast.error(res?.msg);
    }

    if (res?.data?.success) {
      // console.log("res==>>>>>>>", res?.data?.data?.token);
      sessionStorage.setItem("token", res?.data?.data?.token);
      toast.success(res?.data?.msg);
      setTimeout(() => {
        navigate("/dashboard");
      }, 2000);
    }
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const onSubmit = async (data) => {
    Login_Admin(data);
  };

  return (
    <>
      <Row style={{ height: "100vh" }}>
        <Col xs={6} md={6} lg={6}>
          <div className="Center_Div myImgDiv">
            <img src={Logo} className="myImg" alt="logoImg" />
          </div>
        </Col>
        <Col xs={6} md={6} lg={6}>
          <div className=" _Card myLogContainer">
            <div className="_gap_20 myLogForm">
              <div className="log-in-to">Log in to admin panel</div>
              <div className="wordscolors">
                Use your credentials to log in to the dashboard
              </div>
              <div className="Center_Div"></div>
              <form onSubmit={handleSubmit(onSubmit)} className="_gap_20">
                <div className="_gap_5">
                  <label className="label">Email</label>
                  <input
                    className={
                      errors.email ? "INPUT_FIELD ER_BR" : "INPUT_FIELD"
                    }
                    placeholder="Enter Email"
                    type="email"
                    {...register("email", { required: true })}
                  />
                  {errors.email && (
                    <span className="ER_MSG">
                      Please Enter a Valid Email Address
                    </span>
                  )}
                </div>
                <div className="_gap_5 position-relative">
                  <label className="label">Password</label>
                  <div className="password-input-container">
                    <input
                      style={{ width: "100%" }}
                      className={
                        errors.password ? "INPUT_FIELD ER_BR" : "INPUT_FIELD"
                      }
                      type={showPass ? "text" : "password"}
                      placeholder="Enter Password"
                      {...register("password", {
                        required: true,
                        minLength: 4,
                      })}
                    />
                    <FontAwesomeIcon
                      onClick={() => setShowPass(!showPass)}
                      icon={showPass ? faEye : faEyeSlash}
                      className="eyeIcon position-absolute"
                    />
                  </div>
                  {errors.password && (
                    <span className="ER_MSG">Please Enter Valid Password </span>
                  )}
                </div>

                <div className="Start_Div _gap_bit">
                  <label className="label">Remember Me</label>
                  <Switch {...label} defaultChecked={false} />
                </div>

                <div className="W_FULL">
                  <button
                    className="Active_Button W_FULL Borderradius"
                    type="submit"
                  >
                    Login
                  </button>
                </div>
              </form>
              <div></div>
            </div>
          </div>
        </Col>
      </Row>
      <div>
        <Toaster position="top-right" reverseOrder={false} />
      </div>
    </>
  );
};

export default Login;

// import React, { useState, useEffect } from "react";
// import "./Style.css";
// import { Avatar } from "@mui/material";
// import Logo from "../../../assets/images/LOGO/hostHelperImage/image 1 (1).png";
// import { useForm } from "react-hook-form";
// import { ERROR_MSG, SUCCESS_MSG } from "../../../components/Custom_Message";
// import { useNavigate } from "react-router";
// import { ABC } from "../../../Api/Api";
// import { Button, Row, Col } from "react-bootstrap";
// import Switch from "@mui/material/Switch";
// import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import axios from "axios";
// import { Login_Api } from "../../../Api/Api";
// import { Toaster } from "react-hot-toast";
// import toast from "react-hot-toast";
// const Login = () => {
//   const navigate = useNavigate();
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();
//   const [showPass, setShowPass] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   useEffect(() => {
//     // Check if rememberMe flag is set to true, and if so, retrieve email and password from storage
//     const storedEmail = localStorage.getItem("email");
//     const storedPassword = localStorage.getItem("password");
//     if (storedEmail && storedPassword) {
//       // Set the form values
//       setValue("email", storedEmail);
//       setValue("password", storedPassword);
//     }
//   }, []);
//   const { setValue } = useForm();
//   const Login_Admin = async (Credential) => {
//     const res = await Login_Api(Credential);
//     if (res?.success === false) {
//       toast.error(res?.msg);
//     }
//     if (res?.data?.success) {
//       sessionStorage.setItem("token", res?.data?.data?.token);
//       toast.success(res?.data?.msg);
//       setTimeout(() => {
//         navigate("/dashboard");
//       }, 2000);
//     }
//   };
//   const label = { inputProps: { "aria-label": "Switch demo" } };
//   const onSubmit = async (data) => {
//     Login_Admin(data);
//     // If rememberMe is checked, store email and password in local storage
//     if (rememberMe) {
//       localStorage.setItem("email", data.email);
//       localStorage.setItem("password", data.password);
//     } else {
//       // Clear stored email and password if rememberMe is unchecked
//       localStorage.removeItem("email");
//       localStorage.removeItem("password");
//     }
//   };
//   return (
//     <>
//       <Row style={{ height: "100vh" }}>
//         <Col xs={6} md={6} lg={6}>
//           <div className="Center_Div myImgDiv">
//             <img src={Logo} className="myImg" alt="logoImg" />
//           </div>
//         </Col>
//         <Col xs={6} md={6} lg={6}>
//           <div className=" _Card myLogContainer">
//             <div className="_gap_20 myLogForm">
//               <div className="log-in-to">Log in to admin panel</div>
//               <div className="wordscolors">
//                 Use your credentials to log in to the dashboard
//               </div>
//               <div className="Center_Div"></div>
//               <form onSubmit={handleSubmit(onSubmit)} className="_gap_20">
//                 <div className="_gap_5">
//                   <label className="label">Email</label>
//                   <input
//                     className={
//                       errors.email ? "INPUT_FIELD ER_BR" : "INPUT_FIELD"
//                     }
//                     placeholder="Enter Email"
//                     type="email"
//                     {...register("email", { required: true })}
//                   />
//                   {errors.email && (
//                     <span className="ER_MSG">
//                       Please Enter a Valid Email Address
//                     </span>
//                   )}
//                 </div>
//                 <div className="_gap_5 position-relative">
//                   <label className="label">Password</label>
//                   <div className="password-input-container">
//                     <input
//                       style={{ width: "100%" }}
//                       className={
//                         errors.password ? "INPUT_FIELD ER_BR" : "INPUT_FIELD"
//                       }
//                       type={showPass ? "text" : "password"}
//                       placeholder="Enter Password"
//                       {...register("password", {
//                         required: true,
//                         minLength: 4,
//                       })}
//                     />
//                     <FontAwesomeIcon
//                       onClick={() => setShowPass(!showPass)}
//                       icon={showPass ? faEye : faEyeSlash}
//                       className="eyeIcon position-absolute"
//                     />
//                   </div>
//                   {errors.password && (
//                     <span className="ER_MSG">Please Enter Valid Password </span>
//                   )}
//                 </div>
//                 <div className="Start_Div _gap_bit">
//                   <label className="label">Remember Me</label>
//                   <Switch
//                     {...label}
//                     defaultChecked={false}
//                     onChange={() => setRememberMe(!rememberMe)}
//                   />
//                 </div>
//                 <div className="W_FULL">
//                   <button
//                     className="Active_Button W_FULL Borderradius"
//                     type="submit"
//                   >
//                     Login
//                   </button>
//                 </div>
//               </form>
//               <div></div>
//             </div>
//           </div>
//         </Col>
//       </Row>

//       <div>
//         <Toaster position="top-right" reverseOrder={false} />
//       </div>
//     </>
//   );
// };
// export default Login;
